module.exports = __webpack_public_path__ + "static/img/guolv-new.b9a7b138.png";